import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { IExplorableItemTypeInfo } from '~src/ts/models/resourceInfoParts';
import { IGetItemsParams } from '~src/ts/ServerApi/types/IGetItemsParams';
import { IGetItemsResult } from '~src/ts/ServerApi/types/IGetItemsResult';

export interface IResourceGovernanceSettings {
  extractsConcurrencyLimit: number | undefined;
  subscriptionsConcurrencyLimit: number | undefined;
  flowsConcurrencyLimit: number | undefined;
  runtimeLimit: number | undefined;
}

export type IResourceGovernanceSettingsKey = keyof IResourceGovernanceSettings;
export type IResourceGovernanceServerSettingsKey = keyof IResourceGovernanceServerSettings;

export interface IResourceGovernanceSiteSetting extends IExplorableItemTypeInfo<'resourceGovernanceSetting'>, IResourceGovernanceSettings {
  siteId: string;
  siteName: string;
  siteUrlName: string;
  actualRuntime: number; // In hours
  isDefault: boolean;
}

export interface IResourceGovernanceServerSettings extends IResourceGovernanceSettings {
  nextResetAt: number; // Minutes past midnight; TODO: Subject to more discussion
}

export interface IGetResourceGovernanceSiteSettingsResult extends IGetItemsResult {
  settings: Omit<IResourceGovernanceSiteSetting, 'contentType' | 'id'>[];
}
export class GetResourceGovernanceSiteSettingsRequest extends Request<IGetItemsParams, IGetResourceGovernanceSiteSettingsResult> {
  constructor(params: IGetItemsParams) {
    super('getResourceGovernanceSiteSettings', params);
  }
}

export type IResourceGovernanceSiteSettingUpdate = {
  siteIds: string[];
} & Omit<IResourceGovernanceSiteSetting, 'id' | 'siteId' | 'siteName' | 'siteUrlName' | 'actualRuntime' | 'contentType'>;
export class UpdateResourceGovernanceSiteSettingsRequest extends Request<IResourceGovernanceSiteSettingUpdate, IResult> {
  constructor(params: IResourceGovernanceSiteSettingUpdate) {
    super('updateResourceGovernanceSiteSettings', params);
  }
}
export interface IGetResourceGovernanceServerSettingsResult extends IResult {
  governanceServerSettings: IResourceGovernanceServerSettings;
}
export class GetResourceGovernanceServerSettingsRequest extends Request<{}, IGetResourceGovernanceServerSettingsResult> {
  constructor() {
    super('getResourceGovernanceServerSettings', {});
  }
}

export type ResourceGovernanceServerSettingsUpdate = {
  resourceGovernanceServerSettings: IResourceGovernanceServerSettings;
}
export class UpdateResourceGovernanceServerSettingsRequest extends Request<ResourceGovernanceServerSettingsUpdate, IResult> {
  constructor(params: ResourceGovernanceServerSettingsUpdate) {
    super('updateResourceGovernanceServerSettings', params);
  }
}
